// Assessment overview section form field enum
export enum AssessmentOverviewFormField {
  ASSESSMENT_OVERVIEW_APPOINTMENT_TIME = 'assessment-overview/appointment-time'
}
